import { useId } from 'react';

import { paths } from '@farmersdog/constants';
import { ResponsiveText, Link } from '@farmersdog/corgi';
import { PageWidth } from '@farmersdog/corgi-x';

import { Picture } from '../../../components/Picture';

import { freshSources, kibbleSources, meatvegSources } from './assets';
import styles from './WhyFreshIsBest.css';

export interface WhyFreshIsBestProps {
  breed: string;
}

export function WhyFreshIsBest({ breed }: WhyFreshIsBestProps) {
  const id = useId();

  return (
    <section aria-labelledby={id} className={styles.section}>
      <div className={styles.background}>
        <Picture
          sources={freshSources}
          alt="fresh bowl"
          className={styles.fresh}
          height="389"
          width="389"
        />
        <Picture
          sources={kibbleSources}
          alt="kibble bowl"
          className={styles.kibble}
          height="389"
          width="389"
        />
      </div>
      <PageWidth className={styles.content}>
        <ResponsiveText id={id} as="h2" color="kale-3" variant="heading-3">
          Why fresh is best for your {breed}
        </ResponsiveText>
        <div>
          <Picture
            sources={meatvegSources}
            alt="meat and veggie"
            className={styles.icon}
            width="117"
            height="91"
          />
        </div>
        <ResponsiveText
          className={styles.text}
          as="p"
          variant="article-1"
          color="charcoal-3"
        >
          Highly processed kibble can contribute to many issues that can
          compromise your {breed}’s health. Recipes from The Farmer’s Dog are
          made with fresh, human-grade ingredients, steamed to retain nutrients,
          and pre-portioned to help maintain weight.
        </ResponsiveText>
        <Link
          className={styles.cta}
          asButton
          type="primary"
          href={paths.PATH_SIGNUP}
        >
          Feed Fresh Today
        </Link>
      </PageWidth>
    </section>
  );
}
